import { Inject, Injectable, InjectionToken, Injector, Optional } from '@angular/core';
import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { WebinarRunService } from './webinar-run.service';
import { WebinarRunDTO } from './WOWApi.Service';
export const API_BASE_URL2 = new InjectionToken<string>('API_BASE_URL');
@Injectable({
  providedIn: 'root'
})
export class SignalrService {
 private _connection:HubConnection;
 private baseUrl: string;
 private _webinarRunService:WebinarRunService
 private userId: string;
 private webinarId: string;
  constructor(injector: Injector,@Optional() @Inject(API_BASE_URL2) baseUrl?: string) {
  
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    this._webinarRunService = injector.get<WebinarRunService>(WebinarRunService);
   } 

   public async initiateSignalrConnection(userId:string,webinarId:string): Promise<void>
   {
    this.userId = userId;
    this.webinarId = webinarId;
    try 
    {
     this._connection = new HubConnectionBuilder()
     .withUrl(`${this.baseUrl}/runHub?userId=${userId}&runID=${webinarId}`)
     .withAutomaticReconnect([0, 2000, 5000, 10000, 15000, 30000])
     .build();
     // Phone browsers freeze the page during inline/fullscreen video, so the
     // default 30s server timeout can fire before JS wakes up again.
     this._connection.serverTimeoutInMilliseconds = 120000;
     this._connection.keepAliveIntervalInMilliseconds = 15000;

     this._getData();
     await this._connection.start();
     this._invokeServerMethod();

     this._connection.onreconnected(() => {
      this._invokeServerMethod();
      // The DisplaySeats (and later) pushes already fired while we were dead.
      this.refreshLatestRun();
     });

     this._connection.onclose(() => {
      this.tryRestart();
     });

    }
    catch(error)
    {
      console.log(`singlar Error : ${error}`);
    }
   }

   /** Re-open the hub after a phone-browser video freeze dropped it. */
   public async ensureConnected(): Promise<void>
   {
    if (!this._connection || !this.webinarId) {
      return;
    }
    if (this._connection.state === HubConnectionState.Connected) {
      this._invokeServerMethod();
      return;
    }
    if (this._connection.state === HubConnectionState.Connecting ||
        this._connection.state === HubConnectionState.Reconnecting) {
      return;
    }
    try {
      await this._connection.start();
      this._invokeServerMethod();
    } catch (error) {
      console.log(`singlar restart Error : ${error}`);
    }
   }

   public refreshLatestRun(): void
   {
    if (!this.userId || !this.webinarId) {
      return;
    }
    this._webinarRunService
      .GetLatestRun(this.userId, this.webinarId)
      .subscribe({
        next: (data: WebinarRunDTO) => this._webinarRunService.setRealTimeData(data),
        error: (error) => console.log(`GetLatestRun after hub wake failed: ${error}`)
      });
   }

   private tryRestart(): void
   {
    setTimeout(() => { this.ensureConnected(); }, 1500);
   }

   private _getData():void
   {
    const apply = (data: WebinarRunDTO) => {
      this._webinarRunService.setRealTimeData(WebinarRunDTO.fromJS(data));
    };
    // API SendAsync("WebinarRun"); the site historically listened for "webinarRun".
    this._connection.on('WebinarRun', apply);
    this._connection.on('webinarRun', apply);
   }
   private _invokeServerMethod():void
   {
    if (!this._connection || this._connection.state !== HubConnectionState.Connected) {
      return;
    }
    this._connection.invoke('GetConnectionId').then(() => {}).catch(() => {});
   }
}
